<template>
    <div>
        <el-upload
            :limit="1"
            :on-exceed='beyondNum'
            accept="image/png,image/jpg,image/jpeg"
            size="mini"
            multiple
            action=""
            ref="upload"
            :before-upload="beforeAvatarUpload"
            :on-remove="handleRemove"
            :http-request="uploadHttp"
            :file-list="fileList"
            :show-file-list='false'
            class="elUpload">
            <!-- <img :src="url" style="max-height:90px;max-width:100%" alt="" srcset=""> -->
            <el-button size="mini" type="primary" :loading="upBao" :style="styleEd">{{!upBao? url? '已完成':text:$store.getters.is_imgRess+'%'}}<i v-show="!url" class="el-icon-upload el-icon--right"></i></el-button>
        </el-upload>
    </div>
</template>
 
<script>
import utils from '../lib/util'
import os from '../lib/oss'
export default {
    name:'updataImg',
    props:{
        editRrl:String,
        limitSize:String,//大小限制 不传则不限制
        text:{
            type:String,
            default:'上传图片',
        },
        styleEd:{
            type:String,
            default:'',
        }
    },
    data () {
        return {
            fileList:[],
            url:'',
            upBao:false,
            imgSize:'0KB',
        }
    },
    components:{
    },
    computed:{
        ressPuted_img:function(){
            let size = this.imgSize
            let saveGl = size.substring(size.length - 2)
            let maxSize = this.$store.getters.is_imgRess
            return String(utils.unsingNumber(size.replace(/(KB|MB|GB|TB)/g,'')*(String(maxSize).replace(/(%)/g,'')/100),'floor',2))+saveGl
        }
    },
    watch:{
        editRrl:{
            handler(now,old){
                this.editMet()
            }
        },
        deep:true
    },
    mounted: function () {
        this.editMet()
    },
    methods: {
        //编辑
        editMet(){
            this.fileList = []
            if(/(https:|https:)/g.test(this.editRrl)) {
                this.url =  utils.getImgUrl(this.editRrl)[0]
                let a = utils.getImgUrl(this.editRrl)
                if(a.length > 0) {
                    a.forEach(item => {
                        var obj = {}
                        let index = item.lastIndexOf('\/');
                        let fileName  = item.substring(index + 1, item.length);
                        this.$set(obj,'name',fileName);
                        this.$set(obj,'url',this.url);
                        this.fileList.push(obj);
                    })
                }
            }
        },
        //超出最大上传数量
        beyondNum(){
            this.$message.success('最大上传图片数量为 1 张')
        },
        beforeAvatarUpload (file) {
            let strN = file.name.split('.')
            const isJPEG = strN[strN.length-1] === 'jpeg';
            const isJPG = strN[strN.length-1] === 'jpg';
            const isPNG = strN[strN.length-1] === 'png';
            let isSize = this.limitSizeFoo(file.size,this.limitSize)
            if (!isJPG && !isJPEG && !isPNG) {
                this.$message.error('上传图片只能是 JPEG/JPG/PNG 格式!');
            }
            if (!isSize) {
                this.$message.error(`上传图片大小不能超过 ${this.limitSize}KB!`);
            }
            return ((isJPEG || isJPG || isPNG) && isSize);
        },
        limitSizeFoo(isSize,limitSize=null){//KB
            if(limitSize==null) return true
            isSize = isSize / 1000;
            if(Number(isSize)<=Number(limitSize)){
                return true
            }else{
                return false
            }
        },
        close(){
            this.url = ''
            this.$refs.upload.clearFiles();
            this.upBao = false
            os.cancelFun('img');
        },
        //删除图片
        handleRemove(file, fileList) {
            this.fileList = utils.empty(this.fileList)
            this.url = ''
            this.upBao = false
            os.cancelFun('img');
        },
        //阿里云OSS上传
        uploadHttp({ file }) {
            let that = this
            that.upBao = true
            that.imgSize = String(utils.getFileSize(file.size))
            os.uploadHttp(file,function(e,file){
                that.upBao = false
                that.url = e
                that.$emit('upImgUrl',e)
            })
        }
    }
}
</script>
<style>
    .elUpload{
        width: 100%;
    }
    .elUpload .el-upload{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/updataImg.vue